<template>
  <div :class="['order-details-body', cssClass]">
    <div class="order-details-body-bd d-flex justify-content-between">
      <label for="subtotal" class="h6">Subtotal</label>
      <span class="fw-bold">&#8369; {{ putComma(cart.cart_total_amount.toFixed(2)) }}</span>
    </div>
    <div class="order-details-body-bd d-flex justify-content-between" v-for="(fee, index) in cart.fees"
      v-bind:key="index">
      <template v-if="fee.name === 'Delivery Fee'">
        <label :for="`delivery-fee-${index}`" class="text-capitalize h6">Delivery Fee</label>
        <span 
          v-if="['free_delivery', 'delivery_discount'].includes(get(cart, 'voucher_info.promo_code_type'))" 
          :class="['fw-bold', { 'text-line-through': get(cart, 'voucher_info.promo_code_type') === 'free_delivery' }]"
        >
          &#8369; {{ putComma(parseFloat(fee.orig_value).toFixed(2)) }}
        </span>
        <span v-else class="fw-bold">
          {{ fee.calculated_amount ? `&#8369; ${putComma(parseFloat(fee.calculated_amount).toFixed(2))}` : 'FREE' }} 
        </span>
      </template>
      <template v-else>
        <label :for="`fee-name-${index}`" class="text-capitalize h6">{{ fee.name }}</label>
        <span v-if="cart.cart_count != 0" class="fw-bold">&#8369;
          {{ putComma(parseFloat(fee.calculated_amount).toFixed(2)) }}</span>
        <span v-else>&#8369; 0.00</span>
      </template>
    </div>
    <div class="order-details-body-bd d-flex justify-content-between align-items-center mb-2"
      v-if="!isAppliedMedPadalaCredits && medPadalaCustomization">
      <img :src="medPadalaCustomization.logo" alt="MEDPadala Credits" class="medpadala-logo" />
      <span class="text-uppercase text-success" :style="{
        color:
          webDesign && webDesign.design
            ? `${webDesign.design.main_color} !important`
            : null
      }">
        <span class="fw-bold">- &#8369;
          {{
            medPadalaData.amount === null
              ? medPadalaWallet.amount
              : medPadalaData.amount | twoDecimalPlaces
          }}</span>
      </span>
    </div>
    <div class="d-flex justify-content-between align-items-center" v-if="pointsValue / 1">
      <div class="h6 text-success">Points Redeemed</div>
      <span class="text-success">
        - &#8369; {{ pointsValue.toFixed(2) }}
      </span>
    </div>
    <div class="order-details-body-bd d-flex justify-content-between align-items-center"
      v-if="loggedIn && cart.voucher_info">
      <label for="voucher-info-code" class="h6 text-success">Promo ({{ cart.voucher_info.code }})</label>
      <span class="text-success">
        <template v-if="cart.voucher_info.promo_code_type === 'free_delivery'">
            FREE DELIVERY
        </template>
        <template v-else>
          - &#8369; {{ cart.voucher_amount.toFixed(2) }}
        </template>
      </span>
    </div>
    <div class="d-flex justify-content-between align-items-center"
      v-if="loggedIn && cartSpecialDiscount && Number(cartSpecialDiscount.special_discount_computed_amount) > 0">
      <div class="h6 text-success">Promo ({{ specialDiscountLabel[cartSpecialDiscount.special_discount_types] }})
      </div>
      <span class="text-success">
        - &#8369; {{ cartSpecialDiscount.special_discount_computed_amount }}
      </span>
    </div>
    <template v-if="showTotal">
      <CartTotalComponent :cart="cart" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import CartTotalComponent from "./CartTotalComponent.vue";

export default {
  props: {
    cssClass: {},
    cart: {},
    showTotal: {
      type: Boolean,
      default: true
    }
  },
  components: { CartTotalComponent },
  data() {
    return {
      get: _.get,
      specialDiscountLabel: {
        senior: "Senior Citizen",
        pwd: "PWD"
      }
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: "auth/loggedIn",
      medPadalaData: "medpadala/medPadalaData",
      medPadalaCustomization: "medpadala/medPadalaCustomization"
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign,
      cartSpecialDiscount: state => state.cartSpecialDiscount
    }),
    isAppliedMedPadalaCredits() {
      return (
        !this.medPadalaData.appliedCredits &&
        this.cart &&
        this.cart.estore_wallets &&
        !this.cart.estore_wallets
          .map(wallet => wallet.type)
          .includes("med-padala")
      );
    },
    pointsValue: {
      get() {
        return parseFloat(_.get(this.cart, "points_value", 0));
      },
      set(value) {
        return value;
      }
    }
  },
  methods: {
    putComma(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
</script>